import React from 'react';
import { FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT, SPACING } from '../../constants/constants';
import { useThemeTokens } from '../../hooks/UseThemeTokens';

interface Props {
  title:        React.ReactNode;
  description?:  React.ReactNode;
  /** 제목 아래 CTA(사진 등록 요청 등). */
  action?:      React.ReactNode;
  /** action 아래 흐린 각주. */
  footnote?:    React.ReactNode;
  /** 세로 여백. 'lg'(기본)은 큰 빈 상태, 'sm'은 표 안쪽 등 좁은 곳. */
  size?:        'lg' | 'sm';
}

/**
 * 상품 등록 화면의 중앙 정렬 빈 상태(2026-08-31 공통화) — "확장팩을 선택하세요",
 * "검색하세요", "검색 결과 없음(→ 사진 등록 요청)" 세 곳이 제목+설명+선택적 CTA로 구조가
 * 같아 하나로 모은다. antd `<Empty>`(아이콘 위주)와 달리 문장 안내가 주라서 별도로 둔다.
 */
export const RegisterEmptyState: React.FC<Props> = ({ title, description, action, footnote, size = 'lg' }) => {
  const t = useThemeTokens();
  const padY = size === 'lg' ? SPACING.xxl : SPACING.xl;

  return (
    <div style={{ padding: `${padY}px ${SPACING.lg}px`, textAlign: 'center' }}>
      <div style={{ fontSize: FONT_SIZE.md, fontWeight: FONT_WEIGHT.semibold, color: t.textPrimary }}>
        {title}
      </div>
      {description && (
        <div style={{
          fontSize: FONT_SIZE.sm, color: t.textSecondary, marginTop: SPACING.xs, lineHeight: LINE_HEIGHT.relaxed,
        }}>
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: SPACING.md }}>{action}</div>}
      {footnote && (
        <div style={{ fontSize: FONT_SIZE.xs, color: t.textMuted, marginTop: SPACING.sm }}>{footnote}</div>
      )}
    </div>
  );
};
